var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"justify":"center","justify-content":"center"}},_vm._l((_vm.photos),function(photo){return _c('v-col',{key:photo.id,attrs:{"xl":2,"lg":3,"md":4,"sm":6,"cols":10}},[_c('photo-card',{attrs:{"photo":photo}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }